import { useId } from 'react';

export const MultiLineInput = ({ label, name, placeholder, description, onChange, value, lines = 4 }) => {
  const id = useId();
  const descriptionId = useId();
  return (
    <div className="group relative w-full">
      <label
        htmlFor={id}
        className="transtion-all absolute -top-7 left-1 text-xl/6 font-medium text-gray-900 duration-300 group-has-[:focus]:-top-10"
      >
        {label}
      </label>
      <div className="">
        <textarea
          rows={lines}
          id={id}
          name={name}
          placeholder={placeholder}
          aria-describedby={descriptionId}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="focus:outline-pdteal block w-full rounded-md bg-white px-6 py-6 text-2xl text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 sm:text-2xl/6"
        />
      </div>
      {description && (
        <p id={descriptionId} className="mt-2 text-sm text-gray-500">
          {description}
        </p>
      )}
    </div>
  );
};
